module.exports = __webpack_public_path__ + "static/sima-efc07a3ada3f6d54fb6bbb8f2b07ed1d.jpg";